var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'menu-item',
    {
      'highlighted': _vm.isHighlighted,
    },
  ],on:{"click":_vm.onClickMenuItem}},[(_vm.isExternal || !_vm.to)?_c('a',{attrs:{"href":_vm.to}},[_vm._t("default")],2):_c('nuxt-link',{attrs:{"to":_vm.to}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }